export default __webpack_public_path__ + "static/media/NobelWGL-Book.9c4dded9.woff";